const { isEmpty } = require("lodash");
const { ACTION_TYPES } = require("../context/actionTypes");

const updateLoadedData = (dispatch, payload = {}) => {
  let hasNewData = false;

  Object.values(payload).forEach((value) => {
    if (!isEmpty(value)) {
      hasNewData = true;
    }
  });

  if (!hasNewData) {
    return;
  }

  dispatch({ type: ACTION_TYPES.UPDATE_LOADED_DATA, payload });
};

export default updateLoadedData;
